'use strict';

import Player from '@vimeo/player';

const SELECTOR = '.js-header-video';

(function () {
    const elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) {
        return;
    }

    elements.forEach(element => {
        const headerVideoToggleClass = element.dataset.headerVideoToggleClass || 'home-header__video--loaded';
        const iframeSelectorClass = element.dataset.headerVideoIframe || '.home-header__video';
        let headerVideoIframe = document.querySelector(iframeSelectorClass);
        let videos = element.dataset.videos;
        if (!videos) {
            return;
        }
        // Selects a random video from the list
        videos = videos.split('\n');
        const videoIDx = Math.floor(Math.random() * videos.length);
        const videoURL = videos[videoIDx].trim().replace(/.*vimeo\.com.*\/(\d+)$/, 'https://player.vimeo.com/video/$1');

        if (!headerVideoIframe) {
            // Adds the iframe at the beginning of the `headerVideoParent`
            headerVideoIframe = document.createElement('iframe');
            headerVideoIframe.classList.add(iframeSelectorClass.replace('.', ' ').trim());
            headerVideoIframe.width = '100%';
            headerVideoIframe.height = '100%';
            headerVideoIframe.frameborder = '0';
            headerVideoIframe.allow = 'autoplay; fullscreen';
            headerVideoIframe.allowfullscreen = 'allowfullscreen';
            document.querySelector(element.dataset.headerVideoParent).prepend(headerVideoIframe);
        }
        headerVideoIframe.src = `${videoURL}?background=1`;

        const player = new Player(headerVideoIframe);

        player.on('play', () => {
            setTimeout(function(){
                if (headerVideoIframe.classList.contains(headerVideoToggleClass) === false) {
                    headerVideoIframe.classList.add(headerVideoToggleClass);
                }
            }, 750);
        });

    });
}());
